'use client';

import { useEffect } from 'react';
import NextError from 'next/error';

import { errorReport } from '@/libs/error-client';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    errorReport(error, { module: 'global', digest: error.digest });
  }, [error]);

  return (
    <html lang='pl'>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
